/** Простая скользящая средняя (SMA), как на бэкенде `simple_moving_average`. */
export function simpleMovingAverage(prices, endIndex, period) {
    const start = endIndex - period + 1;
    if (start < 0 || period <= 0)
        return null;
    const window = prices.slice(start, endIndex + 1);
    if (window.length !== period)
        return null;
    let sum = 0;
    for (const value of window)
        sum += value;
    return sum / period;
}
/** SMA по всей серии; на первых period−1 барах value = null (точка пропускается). */
export function buildSmaSeries(points, period) {
    if (period <= 0 || points.length === 0)
        return [];
    const prices = points.map((p) => p.price);
    const out = [];
    for (let i = 0; i < points.length; i += 1) {
        const value = simpleMovingAverage(prices, i, period);
        if (value == null)
            continue;
        out.push({ ts: points[i].ts, value });
    }
    return out;
}
/**
 * Пересечения fast/slow на закрытиях баров — та же логика, что `evaluate_ma_cross`
 * (без фильтров позиции/SL/TP).
 */
export function detectMaCrossovers(points, fastPeriod, slowPeriod) {
    if (fastPeriod <= 0 || slowPeriod <= 0 || fastPeriod >= slowPeriod)
        return [];
    if (points.length < slowPeriod + 1)
        return [];
    const prices = points.map((p) => p.price);
    const crosses = [];
    for (let end = slowPeriod; end < prices.length; end += 1) {
        const prevFast = simpleMovingAverage(prices, end - 1, fastPeriod);
        const prevSlow = simpleMovingAverage(prices, end - 1, slowPeriod);
        const currFast = simpleMovingAverage(prices, end, fastPeriod);
        const currSlow = simpleMovingAverage(prices, end, slowPeriod);
        if (prevFast == null || prevSlow == null || currFast == null || currSlow == null)
            continue;
        if (prevFast <= prevSlow && currFast > currSlow) {
            crosses.push({
                ts: points[end].ts,
                price: prices[end],
                side: "BUY",
                fast: currFast,
                slow: currSlow,
            });
        }
        else if (prevFast >= prevSlow && currFast < currSlow) {
            crosses.push({
                ts: points[end].ts,
                price: prices[end],
                side: "SELL",
                fast: currFast,
                slow: currSlow,
            });
        }
    }
    return crosses;
}
export function resolveMaPeriods(fastMa, slowMa) {
    const fast = Number(fastMa);
    const slow = Number(slowMa);
    if (!Number.isInteger(fast) || !Number.isInteger(slow))
        return null;
    if (fast < 2 || slow < 3 || fast >= slow)
        return null;
    return { fast, slow };
}
